import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

interface IProps {
  className?: string;
}

const ReOpen = (props: IProps) => {
  const { className } = props;

  return (
    <SvgIcon className={className} viewBox="200 200 620 620">
      <g>
        <path d="M765,671.91h-95.77V364.52c0-0.13,0-0.26-0.01-0.39c-0.1-8.19-3.46-15.59-8.83-20.96c-5.47-5.47-13.02-8.85-21.36-8.85   h-77.42V306.2c-0.1-8.19-3.46-15.59-8.83-20.96c-5.47-5.47-13.02-8.85-21.36-8.85c-2.56,0-5.05,0.32-7.43,0.92   c-0.08,0.02-0.15,0.04-0.23,0.06l-21.66,5.6l-63.12,16.34c-0.02,0.01-0.04,0.01-0.05,0.02l-86.7,22.45   c-0.03,0.01-0.06,0.01-0.08,0.02l-2.2,0.57c-0.06,0.01-0.12,0.03-0.18,0.05c-4.02,1.24-7.62,3.45-10.52,6.36   c-4.64,4.64-7.51,11.06-7.51,18.14v324.99H235c-5.52,0-10,4.48-10,10v30.01c0,5.52,4.48,10,10,10H765c5.52,0,10-4.48,10-10v-30.01   C775,676.39,770.52,671.91,765,671.91z M619.23,384.32v287.59h-57.62V384.32H619.23z M381.74,365.79l63.25-16.38l29.76-7.71   l36.86-9.55v339.76H381.74V365.79z" />
      </g>
    </SvgIcon>
  );
};

export default ReOpen;
